









































import { createComponent, computed } from "@vue/composition-api";
// eslint-disable-next-line
import { Gender } from "@dcc/types/gender";
import { roundToNDecimalPlaces } from "@dcc/common/rounding";
import { useDictionary } from "@dcc/views/compositions/useDictionary";
import { findGetters } from "@dcc/store/profile/getters";

interface PercentagePopulationProps {
  gender: Gender;
  percentage: number;
  isDrinker: boolean;
}

export default createComponent({
  components: {},
  props: {
    gender: {
      type: Number,
      required: true
    },
    percentage: {
      type: Number,
      required: true
    },
    isDrinker: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  setup(props: Readonly<PercentagePopulationProps>, context) {
    const dictionary = useDictionary();

    const { getGender } = findGetters(context.root.$store);
    const gender = getGender().value;

    const personStr = gender === Gender.Male ? "Man" : "Woman";
    const genderStr = gender === Gender.Male ? "Male" : "Female";

    let selectedPerson = computed(() => {
      let value = props.percentage
        ? Math.floor(Math.floor(props.percentage) / 10)
        : undefined;
      if (value === 10) value = 9; //so that if percentage = 100% the selectedPerson index will be 9 (the last 0-based slot )
      return value;
    });

    const mainPersonImagePath = `${genderStr}`;

    const personImagePath = `${personStr}`;

    const percentageMessage = computed(() => {
      if (!props.isDrinker) {
        return dictionary.dictionary.DCC_Results_PopulationWhoDoNotDrink;
      }

      if (props.gender === Gender.Male) {
        return dictionary.dictionary.DCC_Results_OfMenDrinkLessThanYou;
      } else if (props.gender === Gender.Female) {
        return dictionary.dictionary.DCC_Results_OfWomenDrinkLessThanYou;
      }

      return "";
    });

    return {
      Gender,
      percentageMessage,
      selectedPerson,
      roundToNDecimalPlaces,
      mainPersonImagePath,
      personImagePath,
      ...dictionary
    };
  }
});
